<template>
  <wrap-container>
    <select-options
      label="Producto"
      title="¿Sobre qué producto querés realizar una solicitud?"
    />
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import SelectOptions from "@/components/SelectOptions";

export default {
  name: "Reclamos",
  components: {
    WrapContainer,
    SelectOptions
  }
};
</script>

<style scoped></style>
